/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import { RichText, RichTextComponent } from '@msdyn365-commerce/core';
import classnames from 'classnames';
import { IDobbiesClubComparisonData } from './dobbies-club-comparison.data';
import { IDobbiesClubComparisonProps } from './dobbies-club-comparison.props.autogenerated';

export interface IDobbiesClubComparisonViewProps extends IDobbiesClubComparisonProps<IDobbiesClubComparisonData> {
    moduleProps: IModuleProps;
    contentProps: INodeProps;
    showRichText: React.ReactNode;
}

/**
 *
 * DobbiesClubComparison component
 * @extends {React.PureComponent<IDobbiesClubComparisonProps<IDobbiesClubComparisonData>>}
 */
class DobbiesClubComparison extends React.PureComponent<IDobbiesClubComparisonProps<IDobbiesClubComparisonData>> {
    public render(): JSX.Element | null {
        const { showRichText, className } = this.props.config;
        const viewProps = {
            ...this.props,
            moduleProps: { className: classnames(className), moduleProps: this.props, tag: 'div' },
            contentProps: { tag: 'div' },
            showRichText: this.getStaticRichText(showRichText)
        };
        return this.props.renderView(viewProps) as React.ReactElement;
    }

    /* VSI-Customization -- START Render configureable richtext coming from CMS  */
    private getStaticRichText = (showRichText: RichText | undefined): React.ReactNode => {
        return <div className={classnames(this.props.config.className)}>{showRichText && <RichTextComponent text={showRichText} />}</div>;
    };
    /* VSI-Customization -- END  */
}

export default DobbiesClubComparison;
